import { Component, Input } from '@angular/core';
import { coEventsParameters, EventsProvider } from '../../providers/events/events';
import { AppState } from '../../config/state';
import { ConfigProvider } from '../../providers/config/config';
import { CoEventDetailsComponent } from '../co-event-details/co-event-details';
import { NavController, ModalController, PopoverController } from 'ionic-angular';
import { CoLocationComponent } from '../co-location/co-location';
import moment from 'moment';
import { SocialMediaSharingProvider } from '../../providers/social-media-sharing/social-media-sharing';
/**
 * Generated class for the CoEventsExploreCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-events-explore-card',
  templateUrl: 'co-events-explore-card.html'
})
export class CoEventsExploreCardComponent {
  @Input() event: coEventsParameters;
  @Input() density: any;
  @Input() parentScreen: string;
  private imageSrc: string = null;
  public parentScreenClass: string;
  public agesArray: any;
  private viewType: any;
  isSharedScreen: boolean;
  eventTypes: any;
  constructor( private state: AppState, private config:ConfigProvider, private navCtrl:NavController, public modalCtrl: ModalController, public popoverCtrl: PopoverController, public eventsProvider: EventsProvider, private socialShare: SocialMediaSharingProvider) {
    this.viewType = this.state.mode;
    this.isSharedScreen = this.state.sharedScreen;
    this.eventTypes = this.state.eventColors.types;
  }

  ngOnInit(){
    if(this.event.eventImage){
      this.imageSrc = `https://${this.state.client.keyword}.libnet.info/images/events/${this.state.client.keyword}/${this.event.eventImage}`
    }else{
      this.imageSrc = `https://${this.state.client.keyword}.libnet.info/images/events/${this.state.client.keyword}/` + this.getEventImage(this.event.types[0]);
    }

    this.checkParentScreen(this.parentScreen);
  }

  checkParentScreen(parentScreen){
    switch (parentScreen) {
      case ('main'):
        this.parentScreenClass = 'mainExploreCard';
        break;
      case ('attend'):
        this.parentScreenClass = 'attendExploreCard';
        break;
      default:
        this.parentScreenClass = 'attendExploreCard';
    }
  }

  goToEventDetails(eventId) {
    this.config.load(this.state.appId).then(cfg => {
      this.navCtrl.push(CoEventDetailsComponent, { eventId: eventId.eventId });
    });
  }

  goToLocation(locationId) {
    this.config.load(this.state.appId).then(cfg => {
      this.navCtrl.push(CoLocationComponent, { location: locationId, showNavbar: true });
    });
  }

  getEventImage(eventType) {
    try {
      let eventTypeObject = this.eventTypes.find(object => object.name === eventType);
      if (eventTypeObject.image) return eventTypeObject.image;
      // if (eventTypeObject.icon) {

      // }
    } catch (ex) {
      return "";
    }
  }

  eventCheck(event: any) {
    if (moment().isBefore(event.registrationCloses) && moment().isAfter(event.registrationOpens)) {
      if (event.totalRegistrants === event.maxAttendees) {
        return 'registrationFull'
      } else {
        return "registrationOpen";
      }
    } else if (moment().isBefore(event.registrationOpens)) {
      return "notOpenYet";
    } else {
      return 'registrationClosed';
    }
  }

  openInterestedPopover(event){
    let self = this;
    this.eventsProvider.openInterestedPopover(event, this.event, self);
  }

  shareEvent(button) {
    if (this.viewType === 'app') {
      this.socialShare.shareOptions(this.event);
    } else if (this.viewType === 'desktop') {
      this.eventsProvider.openSocialMediaPopover(button, this.event);
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/co-events-explore-card/co-events-explore-card.ts